export default __webpack_public_path__ + "static/media/mykCement.52e5f4c7.jpg";